import EnvironmentManager from 'Utils/environmentManager';

export const LIVE_STREAM_GEO_BLOCK_ERROR_CODE = -7;
export const LIVE_STREAM_ACCESS_DENIED_CODE = -2;

export const DEFAULT_LIVE_STREAM_GEO_BLOCK_MESSAGE = 'Bu canlı yayın bulunduğunuz bölgede izlenememektedir.';

export const getLiveStreamGeoBlockErrorText = () =>
  EnvironmentManager.getMessageText({ key: 'live_stream_geo_block_error_text' })
  || DEFAULT_LIVE_STREAM_GEO_BLOCK_MESSAGE;

export const createLiveStreamAuthError = (code, description) => ({
  code: Number(code),
  description: description || '',
});

export const createLiveStreamGeoBlockError = () => createLiveStreamAuthError(
  LIVE_STREAM_GEO_BLOCK_ERROR_CODE,
  getLiveStreamGeoBlockErrorText()
);

export const createLiveStreamAuthFailurePayload = (statusCode, statusDescription) => {
  if (Number(statusCode) === LIVE_STREAM_GEO_BLOCK_ERROR_CODE) {
    return createLiveStreamGeoBlockError();
  }

  return createLiveStreamAuthError(statusCode, statusDescription);
};

export const isLiveStreamGeoBlockError = error => {
  if (error == null) {
    return false;
  }

  if (typeof error === 'object') {
    return Number(error.code) === LIVE_STREAM_GEO_BLOCK_ERROR_CODE;
  }

  return Number(error) === LIVE_STREAM_GEO_BLOCK_ERROR_CODE;
};

export const isLiveStreamPlayerError = error => {
  if (error == null || error === LIVE_STREAM_ACCESS_DENIED_CODE) {
    return false;
  }

  if (isLiveStreamGeoBlockError(error)) {
    return false;
  }

  if (typeof error === 'object') {
    const code = Number(error.code);

    if (code === LIVE_STREAM_ACCESS_DENIED_CODE) {
      return false;
    }

    if (error.description) {
      return true;
    }

    return code < 0;
  }

  const code = Number(error);
  return code < 0 && code !== LIVE_STREAM_ACCESS_DENIED_CODE;
};

export const getLiveStreamErrorMessage = error => {
  if (!error) {
    return '';
  }

  if (isLiveStreamGeoBlockError(error)) {
    return getLiveStreamGeoBlockErrorText();
  }

  if (typeof error === 'object' && error.description) {
    return error.description;
  }

  if (typeof error === 'object' && error.message) {
    return error.message;
  }

  if (typeof error === 'object' && error.code != null) {
    return error.description || error.message || '';
  }

  return '';
};

export const getGeoBlockStatusCodeFromErrorResponse = errorData => {
  if (!errorData) {
    return null;
  }

  const code = errorData?.authenticationResult?.statusCode
    ?? errorData?.error?.code
    ?? errorData?.code
    ?? errorData?.statusCode;

  return code != null ? Number(code) : null;
};
